import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "price-search-card" }


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceSearchCard',
  props: {
  options: {
    type: Object,
    required: true,
  },
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  const _component_BaseCalculator = _resolveComponent("BaseCalculator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "price-search-card__top" }, [
      _createElementVNode("div", { class: "price-search-card__title" }, " Ihre Angaben ")
    ], -1)),
    _createVNode(_component_BaseCalculator, {
      postcode: __props.options.postcode,
      "preselected-options": __props.options,
      type: "component"
    }, null, 8, ["postcode", "preselected-options"])
  ]))
}
}

})